module.exports = __webpack_public_path__ + "img/digital-signage-QR-code.7eb24eeb.png";